import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import {
  Breadcrumb,
  BreadcrumbService,
} from '../../../../core/services/utils/bread-crumb.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css',
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];
  isRTL: boolean = false;
  private langChangeSub?: Subscription;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe((crumbs) => {
      this.breadcrumbs = crumbs;
    });

    // Set initial language direction
    this.isRTL = this.translate.currentLang === 'ar';

    // Watch for language changes
    this.langChangeSub = this.translate.onLangChange.subscribe((event) => {
      this.isRTL = event.lang === 'ar';
    });
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe(); // Cleanup
  }
}
